var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('NavigationTop',{attrs:{"path":_vm.path}}),_c('div',{staticClass:"content-block"},[_c('router-view')],1),_c('MyFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }